import React from "react";
import "./index.scss";
import * as _ from "lodash";

const Tooltip = ({ config }) => {
  const visible = _.get(config, "visible", false);
  const text = _.get(config, "text", "");
  const x = _.get(config, "x", 0);
  const y = _.get(config, "y", 0);
  const className = _.get(config, "className", "");

  if (!visible) {
    return <div></div>;
  }

  return (
    <div
      className={`custom-tooltip ${className}`}
      style={{
        top: y + 10,
        left: x + 10,
      }}
    >
      {text}
    </div>
  );
};

export default Tooltip;
